import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { withSystem, withoutSystem } from '../../data/content';
export function BeforeAfterSection() {
  return <section aria-labelledby="compare-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-49" data-mp="1xp3h5h4nfwsp">
      <div className="mx-auto max-w-5xl" data-id="element-50" data-mp="22nohdgjwigh5">
        <SectionHeading id="compare-heading" title={<>
              Imaginez votre prochaine <Accent data-id="element-52" data-mp="1sqjwrl5pet2g">journée de formation…</Accent>
            </>} data-id="element-51" data-mp="22qsrsvnym8g9" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-53" data-mp="1ezdpv403ht5j">
          <div className="rounded-[20px] bg-brand-paper p-7 sm:p-9" data-id="element-54" data-mp="1f0yksuqbne3x">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-charcoal/55" data-id="element-55" data-mp="1jxp03fuay5oa">
              Avant
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-56" data-mp="153akzqduzgew">
              {withoutSystem.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-57" data-mp="1a2546tfqn6zj">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-[#B5655E]" strokeWidth={2.25} aria-hidden="true" data-id="element-58" data-mp="228m1bb84o1l8" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] border-2 border-brand-cta/40 bg-white p-7 shadow-[0_30px_60px_-40px_rgba(76,103,43,0.55)] sm:p-9" data-id="element-59" data-mp="2c730uwl4toiw">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-cta" data-id="element-60" data-mp="1ohqr9vlw7eg2">
              Avec Barber Instructor Ready™
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-61" data-mp="1xa2ivksqt7xm">
              {withSystem.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-62" data-mp="1siarj81riy6f">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-63" data-mp="14rx4jvy1bpip" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-14 max-w-3xl text-center font-display text-[1.8rem] font-bold leading-snug text-brand-charcoal sm:text-[2.2rem]" data-id="element-64" data-mp="2zubqdnskxgka">
          Votre expertise reste essentielle. <Accent data-id="element-65" data-mp="39mpswirher7i">Nos ressources vous aident à mieux la transmettre.</Accent>
        </p>
      </div>
    </section>;
}